import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-pink-100 bg-white px-4 py-12" data-id="element-153" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-154" data-mp="32nun0sijob3h">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-155" data-mp="32pfeuadh5fxn">
          🏃‍♀️ Combo Completo Jumping 2026
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-156" data-mp="3uf0phflqmkvx">
          El sistema de enseñanza N°1 para instructores de Jumping de todos los niveles en
          Argentina.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-157" data-mp="36muiocgf6ul">
          Porque enseñar jumping no debería costarte todos los domingos del año.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-158" data-mp="3qcdsl0a7m9rv">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="mailto:compradigitalyaa@gmail.com" data-id="element-159" data-mp="29xvswiphtnry">
            <MailIcon className="h-4 w-4" data-id="element-160" data-mp="3l9shv2i5sonf" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-161" data-mp="3gc0ftfnsvm5i">
            <GlobeIcon className="h-4 w-4" data-id="element-162" data-mp="82ienymgqkhh" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-163" data-mp="33xefz77o0t1">
            <InstagramIcon className="h-4 w-4" data-id="element-164" data-mp="cu8qya4ynibj" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-pink-100 pt-6" data-id="element-165" data-mp="qu1fpzwxfogv">
          <p className="text-base font-black text-ink" data-id="element-166" data-mp="msg74qrfdwch">
            🏃‍♀️ “El próximo domingo puede ser diferente.”
          </p>
          <p className="mt-1 text-sm font-semibold italic text-primary" data-id="element-167" data-mp="twfmxpvnlpqb">
            “¡Finalmente un domingo sin Jumping!”
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-168" data-mp="yruz8de0jdkm">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-169" data-mp="18k94hg4av2bj" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}